import { useEditorState } from 'platejs/react';

import RedoIcon from '../../../icons/redo.svg?react';
import UndoIcon from '../../../icons/undo.svg?react';
import { ToolbarButton } from './ToolbarButton';

export const HistoryToolbarButtons = ({
  redoLabel = 'Redo',
  undoLabel = 'Undo',
}: {
  redoLabel?: string;
  undoLabel?: string;
}) => {
  const editor = useEditorState();

  return (
    <>
      <ToolbarButton
        aria-label={undoLabel}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();

          editor.tf.undo();
        }}
      >
        <UndoIcon />
      </ToolbarButton>
      <ToolbarButton
        aria-label={redoLabel}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();

          editor.tf.redo();
        }}
      >
        <RedoIcon />
      </ToolbarButton>
    </>
  );
};
